import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=313f2012&"
import script from "./Identification.vue?vue&type=script&lang=js&"
export * from "./Identification.vue?vue&type=script&lang=js&"
import style0 from "./Identification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports